// V6: Om symbol spins in, glows, card expands from center
import { useCurrentFrame, useVideoConfig, interpolate, Easing, AbsoluteFill, spring } from "remotion";
import { loadFont as loadInter } from "@remotion/google-fonts/Inter";
import { loadFont as loadDev } from "@remotion/google-fonts/TiroDevanagariHindi";

const { fontFamily: inter } = loadInter("normal", { weights: ["600", "700", "800"], subsets: ["latin"] });
const { fontFamily: devFont } = loadDev("normal", { weights: ["400"], subsets: ["devanagari"] });

const ThumbUpSVG: React.FC = () => (
  <svg width="12" height="12" viewBox="0 0 64 64" fill="none">
    <path d="M20 28L28 8C30 8 34 9 34 16V24H52C54 24 56 26 55 30L50 52C49 54 47 55 45 55H20V28Z" fill="white" />
    <rect x="8" y="28" width="12" height="28" rx="3" fill="white" />
  </svg>
);

export const DevaKathaLS6: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const omSpin = interpolate(frame, [0, Math.round(1 * fps)], [360, 0], { extrapolateRight: "clamp", extrapolateLeft: "clamp", easing: Easing.out(Easing.cubic) });
  const omScale = spring({ frame, fps, config: { damping: 10, stiffness: 80 }, durationInFrames: Math.round(1 * fps) });
  const omS = interpolate(omScale, [0, 1], [0.2, 1]);

  const omGlow = interpolate(frame, [Math.round(0.8 * fps), Math.round(1.3 * fps), Math.round(1.8 * fps)], [0, 1, 0.3], { extrapolateRight: "clamp", extrapolateLeft: "clamp" });

  const cardScale = spring({ frame: Math.max(0, frame - Math.round(0.9 * fps)), fps, config: { damping: 14, stiffness: 100 }, durationInFrames: Math.round(0.8 * fps) });
  const cardS = interpolate(cardScale, [0, 1], [0, 1]);

  const likeClicked = frame >= Math.round(1.8 * fps);
  const subClicked = frame >= Math.round(2.6 * fps);

  const likeScale = interpolate(frame, [Math.round(1.8 * fps), Math.round(1.87 * fps), Math.round(2.0 * fps)], [1, 0.86, 1.07], { extrapolateRight: "clamp", extrapolateLeft: "clamp" });
  const subScale = interpolate(frame, [Math.round(2.6 * fps), Math.round(2.67 * fps), Math.round(2.8 * fps)], [1, 0.86, 1.07], { extrapolateRight: "clamp", extrapolateLeft: "clamp" });

  const fadeOut = interpolate(frame, [Math.round(3.5 * fps), Math.round(4 * fps)], [1, 0], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });

  return (
    <AbsoluteFill style={{ overflow: 'hidden' }}>
      <div style={{ position: 'absolute', inset: 0, opacity: fadeOut, transform: 'scale(1.5)', transformOrigin: 'bottom right' }}>
      <div style={{ position: "absolute", bottom: 40, right: 40, display: "flex", alignItems: "center", gap: 13 }}>
        <div style={{
          transform: `rotate(${omSpin}deg) scale(${omS})`,
          filter: `drop-shadow(0 0 ${13 * omGlow}px rgba(255,215,0,${omGlow}))`,
        }}>
          <svg width="53" height="53" viewBox="0 0 80 80">
            <circle cx="40" cy="40" r="38" fill="rgba(0,0,0,0.6)" stroke="rgba(255,215,0,0.5)" strokeWidth="2" />
            <text x="40" y="54" textAnchor="middle" fontSize="29" fill="#FFD700" fontFamily={devFont} fontWeight="bold">ॐ</text>
          </svg>
        </div>

        <div style={{
          transform: `scale(${cardS})`, transformOrigin: "left center",
          background: "rgba(10,8,4,0.9)", backdropFilter: "blur(12px)",
          borderRadius: 11, padding: "9px 15px",
          border: "1px solid rgba(255,215,0,0.4)",
          boxShadow: "0 8px 32px rgba(0,0,0,0.6)",
          display: "flex", flexDirection: "column", gap: 7, minWidth: 160,
        }}>
          <span style={{ color: "#FFD700", fontSize: 9, fontWeight: 600, fontFamily: inter, letterSpacing: 1.2, textTransform: "uppercase" }}>Deva Katha</span>
          <div style={{ display: "flex", gap: 7 }}>
            <div style={{
              display: "flex", alignItems: "center", gap: 4,
              background: likeClicked ? "#1a73e8" : "rgba(255,255,255,0.1)",
              border: `1px solid ${likeClicked ? "transparent" : "rgba(255,255,255,0.15)"}`,
              borderRadius: 15, padding: "5px 11px",
              transform: `scale(${likeScale})`,
            }}>
              <ThumbUpSVG />
              <span style={{ color: "#fff", fontSize: 10, fontWeight: 700, fontFamily: inter, whiteSpace: "nowrap" }}>{likeClicked ? "Liked!" : "Like"}</span>
            </div>
            <div style={{
              display: "flex", alignItems: "center",
              background: subClicked ? "#606060" : "#FF0000",
              borderRadius: 15, padding: "5px 11px",
              transform: `scale(${subScale})`,
              boxShadow: subClicked ? "none" : "0 4px 18px rgba(255,0,0,0.5)",
            }}>
              <span style={{ color: "#fff", fontSize: 10, fontWeight: 800, fontFamily: inter, whiteSpace: "nowrap" }}>{subClicked ? "Subscribed ✓" : "Subscribe"}</span>
            </div>
          </div>
        </div>
      </div>
      </div>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
